import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import {Link} from "@mui/material";

import ArrowRightIcon from "components/icons/ArrowRightIcon";

import {black500, greyishBlue100} from "assets/jss/main";

ShowMoreButton.propTypes = {
    onClick: PropTypes.func,
    labelId: PropTypes.string,
};

function ShowMoreButton({onClick = () => {}, labelId = "dashboard.topProducts.showMore", ...props}) {
    return (
        <div style={{
            padding: '16px 20px',
            display: 'flex',
            borderTop: `1px solid ${greyishBlue100}`,
            justifyContent: "center",
        }}>
            <Link
                component="button"
                onClick={onClick}
                sx={{
                    fontSize: "14px",
                    color: black500,
                    cursor: "pointer",
                    textDecoration: 'none',
                    display: 'flex',
                    alignItems: "center",
                }}
            >
                <div style={{marginRight: "8px"}}>
                    <FormattedMessage id={labelId} />
                </div>
                <ArrowRightIcon size={16}/>
            </Link>
        </div>
    );
}

export default ShowMoreButton;
